import { render, staticRenderFns } from "./PersonOrgDeals.vue?vue&type=template&id=727d5a50&"
import script from "./PersonOrgDeals.vue?vue&type=script&lang=js&"
export * from "./PersonOrgDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports